import { ISolicitudDocumentoTecnicoValidarModel } from "../../interfaces/solicitud/documento-tecnico/ISolicitudDocumentoTecnicoValidarModel";
import { ISolicitudDocumentoModel } from "../../interfaces/solicitud/documento/ISolicitudDocumentModel";
import { SolicitudDocumentoModel } from "../documento/SolicitudDocumentoModel";

export class SolicitudDocumentoTecnicoValidarModel implements ISolicitudDocumentoTecnicoValidarModel {
    idSolicitud: number;
    documentos: ISolicitudDocumentoModel[];
    comentarios: string;
    idEstado: number;

    constructor(){
        this.idSolicitud = 0;
        this.documentos = new Array<SolicitudDocumentoModel>();
        this.comentarios = '';
        this.idEstado = 0;
    }
}